import { Route } from "react-router-dom";
import React, { useEffect } from "react";
import LobConstants from "../../../constants/LobConstants";
import RebateTransactionMaster from "./RebateTransactionMaster";
import RebateSummaryReport from "./RebateSummaryReport";
import ReportTabs from "./TAT Report/ReportTabs";

export default function ReportView() {
  useEffect(() => { }, []);
  return (
    <div>
      <Route
        path={`/${LobConstants.LOB}/reports/rebatetransactionreport`}
        component={RebateTransactionMaster}
      />
      <Route
        path={`/${LobConstants.LOB}/reports/rebatesummaryreport`}
        component={RebateSummaryReport}
      />
      <Route
        path={`/${LobConstants.LOB}/reports/tatreport`}
        component={ReportTabs}
      />
    </div>
  );
}
